/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'

import PitchPillElement from './PitchPillElement.tsx'
import SortableWrapper from './SortableWrapper.tsx'
import RemoveButton from './RemoveButton.tsx'

import { StatPickerDraggableElementProps } from './utils/types.ts'

import { PITCH_ARSENAL_STATS, prettyStatNames } from './utils/stat-groupings.ts'
import {
    ROW_HEIGHT,
    TRUNCATE_TEXT_CUTOFF,
    TRUNCATE_TEXT_LENGTH,
    CLICK_AREA_WIDTH,
} from './utils/constants.ts'

import { useDimensions } from './utils/responsive-dimensions.tsx'

export default function StatPickerDraggableElement({
    stat,
    draftSelected,
    type,
    index,
    groupRefs,
    currentType,
    handleToggleStat,
}: StatPickerDraggableElementProps) {
    const { STAT_DRAG_RECT_WIDTH, REMOVE_BUTTON_X } = useDimensions()

    const globalIndex = draftSelected.indexOf(stat)
    const relativeY = index * ROW_HEIGHT
    const prettyStatName =
        stat === 'percent_rank_swing_take_run_value' &&
        currentType === 'pitcher'
            ? 'Pitching'
            : prettyStatNames[stat]

    const isArsenal = PITCH_ARSENAL_STATS.has(stat)

    let arsenalPitchType
    let arsenalPitchStat

    if (isArsenal) {
        ;[arsenalPitchType, arsenalPitchStat] = stat.split('_percent_rank_')
    }

    return (
        <SortableWrapper
            key={stat}
            id={stat}
            index={globalIndex}
            offset={relativeY}
            groupName={`draft-stats-${type}`}
            type="stat"
            container={groupRefs.current[type]}
        >
            <rect
                width={STAT_DRAG_RECT_WIDTH}
                height={30}
                x={8}
                rx={4}
                className="stat-picker-sortable-rect"
            />
            {!isArsenal && (
                <text x={16} y={20} className="stat-picker-sortable-text">
                    {prettyStatName.length > TRUNCATE_TEXT_CUTOFF
                        ? `${prettyStatName.substring(
                              0,
                              TRUNCATE_TEXT_LENGTH
                          )}...`
                        : prettyStatName}
                </text>
            )}
            {isArsenal && (
                <PitchPillElement
                    x={10}
                    y={9}
                    textClass="stat-picker-sortable-text"
                    pitchType={arsenalPitchType!}
                    statName={arsenalPitchStat!}
                    flipOrder={false}
                    rightJustify={false}
                />
            )}
            <rect
                x={8}
                y={0}
                width={CLICK_AREA_WIDTH}
                height={30}
                fill="transparent"
            />
            <g
                onPointerDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                    e.stopPropagation()
                    handleToggleStat(stat)
                }}
                style={{
                    cursor: 'pointer',
                }}
            >
                <RemoveButton x={REMOVE_BUTTON_X} y={15} symbol="×" />
            </g>
        </SortableWrapper>
    )
}
